import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=a556ea54&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"
import style0 from "./Verification.vue?vue&type=style&index=0&id=a556ea54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a556ea54",
  null
  
)

export default component.exports